import { render } from "./CommonMessageBox.vue?vue&type=template&id=35585f97&scoped=true"
import script from "./CommonMessageBox.vue?vue&type=script&lang=js"
export * from "./CommonMessageBox.vue?vue&type=script&lang=js"

import "./CommonMessageBox.vue?vue&type=style&index=0&id=35585f97&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35585f97"]])

export default __exports__